import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle, Spinner, Badge } from '@shared/ui';
import { auditApi } from '@entities/audit';
import { formatDateTime } from '@shared/lib/format';

export function RecentAudit() {
  const { t } = useTranslation();
  const { data, isLoading } = useQuery({
    queryKey: ['audit', 'recent'],
    queryFn: () => auditApi.list({ size: 20 }),
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('dashboard.recentAudit')}</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex justify-center py-6">
            <Spinner />
          </div>
        ) : !data?.content.length ? (
          <p className="text-sm text-muted-foreground">{t('common.empty')}</p>
        ) : (
          <ul className="divide-y">
            {data.content.map((entry) => (
              <li key={entry.id} className="flex items-center justify-between py-2 text-sm">
                <div className="flex items-center gap-2">
                  <Badge variant="outline" className="font-mono">
                    {entry.action}
                  </Badge>
                  {entry.targetType ? (
                    <span className="text-xs text-muted-foreground">
                      {entry.targetType}
                      {entry.targetId ? ` · ${entry.targetId.slice(0, 8)}…` : ''}
                    </span>
                  ) : null}
                </div>
                <time className="text-xs text-muted-foreground">{formatDateTime(entry.at)}</time>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
